import styled, { StyledComponentClass } from 'styled-components';
import colors from '../../styles/colors';

const StackedListHeader: StyledComponentClass<any, any> = styled.div`
  border-bottom: 1px solid ${colors.grey300};
  height: 70px;
  width: 100%;
  padding: 8px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export default StackedListHeader;
